// extracted by mini-css-extract-plugin
module.exports = {"root":"_dfd697","teal":"_146b6e","purple":"_23dbaf"};